module.exports = {
  Components: (globalThis as any).WebChat.Components,
  hooks: (globalThis as any).WebChat.hooks,
  testIds: (globalThis as any).WebChat.testIds
};
